import { render, staticRenderFns } from "./CommonSpeakingTyResult.vue?vue&type=template&id=6285e0c5&scoped=true"
import script from "./CommonSpeakingTyResult.vue?vue&type=script&lang=js"
export * from "./CommonSpeakingTyResult.vue?vue&type=script&lang=js"
import style0 from "./CommonSpeakingTyResult.vue?vue&type=style&index=0&id=6285e0c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6285e0c5",
  null
  
)

export default component.exports